// extracted by mini-css-extract-plugin
export default {"base":"Textarea_base__2ajv5","isDisabled":"Textarea_isDisabled__2kmar","isError":"Textarea_isError__IzOsv"};